import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import { Error } from './Error';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  render() {
    return this.state.error ? /*#__PURE__*/_jsx(NavMarker, {
      name: this.props.marker,
      children: /*#__PURE__*/_jsx(Error, {})
    }) : this.props.children;
  }
}
ErrorBoundary.defaultProps = {
  marker: 'DYNAMIC_WIDGET_PAGE_ERROR'
};